var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-container"},[_c(_vm.goodsComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }